import { NEWBUILDING_KPN_CHAT } from 'node/services/fetchExperiments/getExperiments';

import { NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB } from 'shared/hooks/selectors/useNewbuildingBuzzoolaIntegrationTestWebAvailable';
// eslint-disable-next-line import/no-cycle
import {
  NEWBUILDING_TRUST_AND_SAFETY,
  NEWBUILDING_RENT_TRAP,
  NEWBUILDING_SUBURBAN_TRAP,
  NEWBUILDING_FLAT_SALE_TRAP,
  CHATS_NEW_SEND_MESSAGE_FROM_OBJECT_CARD,
  CPD_LABEL_EXPERIMENT,
} from 'shared/selectors/abExperiments';
import { CPD_TRAP_EXPERIMENT_NAME } from 'shared/selectors/abExperiments/selectCPDTrapGroup';

export const EXPERT_OPINION = 'aud_desktop_bx495_expert_opinion_gpt_newb';

export const EXPERIMENTS: string[] = [
  NEWBUILDING_TRUST_AND_SAFETY,
  NEWBUILDING_RENT_TRAP,
  NEWBUILDING_SUBURBAN_TRAP,
  NEWBUILDING_FLAT_SALE_TRAP,
  CHATS_NEW_SEND_MESSAGE_FROM_OBJECT_CARD,
  /**
   * @todo Удалить переменную
   * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
   */
  NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB,
  CPD_TRAP_EXPERIMENT_NAME,
  EXPERT_OPINION,
  CPD_LABEL_EXPERIMENT,
  NEWBUILDING_KPN_CHAT,
];
